import { useRef } from "react";
import { Container, TextBox1, TextBox2, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const RecoveryCom2 = ({ t }) => {
  const ref1 = useRef();
  useScrollFadeIn(ref1);
  return (
    <Wrapper ref={ref1} className="fade-in">
      <TextBox1>
        <span>{t("recover-2-1")}</span>
        <span>{t("recover-2-2")}</span>
      </TextBox1>
      <Container>
        <TextBox2>
          <img
            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/79ec8d87UsingWallet_16.png"
            alt="니모닉 phone"
          />
          <span>{t("recover-2-3")}</span>
          <span>
            <span>{t("recover-2-4")}</span>
            <span>{t("recover-2-5")}</span>
          </span>
        </TextBox2>
        <TextBox2>
          <img
            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/bda40c14UsingWallet_17.png"
            alt="개인키로 복구 phone"
          />
          <span>{t("recover-2-6")}</span>
          <span>
            <span>{t("recover-2-7")}</span>
            <span>{t("recover-2-8")}</span>
          </span>
        </TextBox2>
      </Container>
    </Wrapper>
  );
};

export default RecoveryCom2;
